import { Component, Input } from '@angular/core'
import { getTreeCategorySpecialWithValue } from 'src/app/_helpers/Utils'
import { Tree } from 'src/app/models/Reports'
import { ISpecies } from 'src/app/models/Species'

@Component({
	selector: 'app-tree-informations',
	templateUrl: './tree-informations.component.html'
})
export class TreeInformationsComponent {
		@Input() public allSpecies: Array<ISpecies> = []
	@Input() public tree: Tree = new Tree()
	@Input() public disabled: boolean = true

	public hasChangeSpecie(nameSpecie: string) {
		const findSpecie = this.allSpecies.find(item => {
			return (item.nomenclature.popularName === nameSpecie || item.nomenclature.scientificName === nameSpecie) && !item.inactive
		})

		if (findSpecie) {
			this.tree.specieId = findSpecie._id
			this.tree.specie = findSpecie.nomenclature.scientificName
			this.tree.popularName = findSpecie.nomenclature.popularName
			this.tree.family = findSpecie.nomenclature.botanicalClassification
			this.tree.source = findSpecie.characterization.origin
			this.tree.specialCategory =
				getTreeCategorySpecialWithValue(findSpecie.evaluationComponents.specialCategory)
		}
	}

	public onChangeInputMensurament(event: {
		fieldName: string,
		value: number
	}) {

		if (event.fieldName.includes('totalHeight')) {
			this.tree.totalHeight = String(event.value)
		}
		if (event.fieldName.includes('dapCap')) {
			this.tree.dapCap = String(event.value)
		}
		if (event.fieldName.includes('stemHeight')) {
			this.tree.stemHeight = String(event.value)
		}
		if (event.fieldName.includes('cupProjection')) {
			this.tree.cupProjection = String(event.value)
		}
	}

	public hasChangeFormat(format: string) {
		if (format === 'Regular') {
			this.tree.treeFormat.url = 'regular_small.svg'
		} else if (format === 'Irregular') {
			this.tree.treeFormat.url = 'irregular_small.svg'
		} else if (format === 'Elíptica vertical') {
			this.tree.treeFormat.url = 'elivertical_small.svg'
		} else if (format === 'Elíptica horizontal') {
			this.tree.treeFormat.url = 'elihorizontal_small.svg'
		} else if (format === 'Cônica') {
			this.tree.treeFormat.url = 'conica_small.svg'
		} else if (format === 'Palmeira') {
			this.tree.treeFormat.url = 'palmeira_small.svg'
		}
	}
}
